import { ServiceType as RSDKServiceType } from '@rover/rsdk/src/apiClient/latest';
import filtersToURLSearchParams from '@rover/shared/js/search/utilities/filtersToURLSearchParams';
import { SearchFilters } from '@rover/types';
import { ServiceType } from '@rover/types/src/ServiceType';

const getSearchUrl = (
  filters: Partial<SearchFilters>,
  language: string,
  serviceTypeConfig?: ServiceType | RSDKServiceType | null | undefined,
  isDirty: boolean = false
): string => {
  const urlSearchParams = filtersToURLSearchParams(filters, serviceTypeConfig, isDirty, language);
  return `/search/?${urlSearchParams.toString()}`;
};

export default getSearchUrl;
